/* jshint esnext: true */
import {$document, $window, $html, $body} from './utils/environment';
import {getNodeData} from './utils/html';

// Global functions and tools
import globals from './utils/globals';

// Basic modules
import * as modules from './modules';

class App {
    constructor() {
        this.modules        = modules;
        this.currentModules = [];

        $document.on('initModules.App', (event) => {
            this.initGlobals(event.firstBlood)
                .deleteModules()
                .initModules();
        });
    }

    /**
     * Destroy all existing modules
     * @return  {Object}  this  Allows chaining
     */
    deleteModules() {
        // Loop modules
        var i = this.currentModules.length;

        // Destroy all modules
        while (i--) {
            this.currentModules[i].destroy();
            this.currentModules.splice(i);
        }

        return this;
    }

    /**
     * Execute global functions and settings
     * Allows you to initialize global modules only once if you need
     * (ex.: when using Barba.js or SmoothState.js)
     * @return  {Object}  this  Allows chaining
     */
    initGlobals(firstBlood) {
        globals(firstBlood);
        return this;
    }

    /**
     * Find modules and initialize them
     * @param {DOMNode} scope Scope as to where you want to init modules.
     * @return  {Object}  this  Allows chaining
     */
    initModules(scope) {
        // Elements with module
        if (scope) {
            if (typeof scope.querySelectorAll === 'function') {
                var moduleEls = scope.querySelectorAll('[data-module]');
            }
        }

        // No scope, or invalid scope.
        if (typeof moduleEls === 'undefined') {
            var moduleEls = document.querySelectorAll('[data-module]');
        }


        // Loop through elements
        var i      = 0;
        var elsLen = moduleEls.length;

        for (; i < elsLen; i++) {

            // Current element
            let el = moduleEls[i];

            // All data- attributes considered as options
            let options = this.getElemData(el);

            // Add current DOM element and jQuery element
            options.el  = el;
            options.$el = $(el);

            // Module does exist at this point
            let attr = options.module;

            // Splitting modules found in the data-attribute
            let moduleIdents = attr.replace(/\s/g, '').split(',');

            // Loop modules
            let j          = 0;
            let modulesLen = moduleIdents.length;

            for (; j < modulesLen; j++) {
                let moduleAttr = moduleIdents[j];
                let modules    = $(el).data('_modules');

                // Module already instanciated.
                if (modules) {
                    if (typeof modules[moduleAttr] != 'undefined') {
                        // Maybe reinit?
                        continue;
                    }
                }

                if (!modules) {
                    modules = {};
                }

                if (typeof this.modules[moduleAttr] === 'function') {
                    let module          = new this.modules[moduleAttr](options);
                    modules[moduleAttr] = module;
                    this.currentModules.push(module);
                    $(el).data('_modules', modules);
                }
            }
        }

        return this;
    }

    /**
     * Get element data attributes
     * @param   {DOMElement}  el
     * @return  {Array}       data
     */
    getElemData(el) {
        // All attributes
        var attributes = el.attributes;

        // Regex Pattern
        var pattern = /^data\-(.+)$/;

        // Output
        var data = {};

        for (let i in attributes) {
            if (!attributes[i]) {
                continue;
            }
            // Attributes name (ex: data-module)
            let name = attributes[i].name;

            // This happens.
            if (!name) {
                continue;
            }

            let match = name.match(pattern);
            if (!match) {
                continue;
            }

            // If this throws an error, you have some
            // serious problems in your HTML.
            data[match[1]] = el.getAttribute(name);
        }

        return data;
    }
}

// IIFE for loading the application
// ==========================================================================
(function () {
    let loaded  = false;
    let maxLoad = 3000;

    // On load
    // ==========================================================================
    $window.on('load', function () {
        if (!loaded) {
            loaded = true;
            load();
        }
    });

    // Maximum load
    // ==========================================================================
    setTimeout(function () {

        if (!loaded) {
            loaded = true;
            load();
        }
    }, maxLoad);

    // Load
    // ==========================================================================
    function load() {
        // SmoothScroll is ready
        // $document.on('isReady.SmoothScroll', (event) => {
        //     $body.addClass('is-loaded');
        // });

        // load app
        window.App = new App();
        $document.trigger({
            type: 'initModules.App',
            firstBlood: true
        });

        // add class for IE and iOS browser
        if (window.navigator.userAgent.match(/Edge/) || window.navigator.userAgent.match(/Trident/)) {
            $body.addClass('is-ie');
        }
        if (window.navigator.userAgent.match(/Edge/)) {
            $body.addClass('is-edge');
        }
        if (window.navigator.userAgent.match(/Trident/)) {
            $body.addClass('is-trident');
        }
        if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
            $body.addClass('is-ios');
        }
        if (!!navigator.platform && /Win16|Win32|Win64/.test(navigator.platform)) {
            $body.addClass('is-windows');
        }
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        if(isFirefox){
            $body.addClass('is-firefox');
        }

        if (window.location.href.indexOf('?app=true') > 0) {
            window.sessionStorage.setItem('volleyball-app', 1);
        } else if (window.location.href.indexOf('?app=false') > 0) {
            window.sessionStorage.removeItem('volleyball-app');
        }
        if (window.sessionStorage.getItem('volleyball-app')) {
            $html.addClass('has-nav-hidden');
        }

        // si on est pas sur la home
        if (!$body.hasClass('is-transitions-loader')) {
            setTimeout(() => {
                $body.addClass('is-loaded').removeClass('is-transitions-masks');
            }, 300);
        } else {
            setTimeout(() => {
                $body.addClass('is-loaded').removeClass('is-transitions-loader');
            }, 300);
        }
    }
})();
